<template>
  <b-overlay
    :show="busy"
    spinner-type="grow"
    spinner-variant="primary"
    rounded="sm"
  >
    <b-card class="border-none py-0 mb-0 px-1">
      <b-card-body class="py-0">
        <b-row>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
              <treeselect
                placeholder="Select slac..."
                searchPromptText="Type at least 3 chars..."
                v-model="item.slac"
                :clearable="true"
                :async="true"
                :load-options="treeselect_loadSLAC"
                :show-count="true"
                :flatten-search-results="true"
                :disable-branch-nodes="true"
                :matchKeys="['id']"
                search-nested
              >
                <div slot="value-label" slot-scope="{ node }">
                  {{ node.raw.id }}
                </div>
              </treeselect>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label-cols="12" label="Event" label-size="sm">
              <treeselect
                placeholder="Select event..."
                v-model="item.eventcode"
                :clearable="true"
                :async="true"
                :load-options="treeselect_loadEvent"
                searchPromptText="Type at least 4 chars..."
                :show-count="true"
                :flatten-search-results="true"
                :disable-branch-nodes="true"
                :matchKeys="['id']"
                search-nested
                :disabled="readonly"
              >
                <div slot="value-label" slot-scope="{ node }">
                  {{ node.raw.id }}
                </div>
              </treeselect>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label-cols="12" label="Date Travel" label-size="sm">
              <b-input-group>
                <b-form-datepicker
                  v-model="item.datetravel"
                  size="sm"
                  label-help
                  hide-header
                  locale="en-GB"
                  placeholder="Select date"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                ></b-form-datepicker>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="item.datetravel = null"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group
              label="Your Ref/PO"
              label-for="yourref"
              label-cols="12"
            >
              <b-input-group>
                <b-form-input
                  type="text"
                  v-model="item.yourref"
                  placeholder="Your Ref/PO"
                  size="sm"
                  :disabled="readonly"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    :disabled="true"
                    variant="outline-secondary"
                    @click="item.yourref = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <b-card class="border-none py-0 mb-0 px-1">
      <b-card-header class="py-1 mb-2">
        <i :class="options.icon" class="mr-1"></i>
        {{ item.ref }} Lines
        <span class="text-warning"
          >&lt;{{ !item.ref ? "new" : "edit" }}&gt;</span
        >
      </b-card-header>

      <b-card-body class="py-0">
        <div>
          <b-overlay
            :show="options.overlay_show"
            opacity=".9"
            v-click-outside="outside"
          >
            <div class="availtable datatable nested">
              <b-table
                :dark="$store.state.darkMode"
                :ref="options.bvtid"
                sticky-header="350px"
                striped
                hover
                small
                caption-bottom
                show-empty
                selectable
                select-mode="multi"
                foot-clone
                no-footer-sorting
                :busy="this[options.bvtid + '_busy']"
                :items="this[options.bvtid + '_items']"
                :fields="options.fields"
                :filter="this[options.bvtid + '_find']"
                @row-selected="rowSelected($event, options.bvtid)"
              >
                <template #head(selected)>
                  <i
                    id="selectall"
                    class="ml-1"
                    :class="headselected(options.bvtid)"
                    aria-hidden="true"
                    @click="headselectedClick(options.bvtid)"
                    title="Click to select/unselect all"
                  ></i>
                  <b-tooltip
                    target="selectall"
                    triggers="hover"
                    placement="right"
                    >Click to select/unselect all</b-tooltip
                  >
                </template>
                <template #cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                  </template>
                </template>
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner
                      type="grow"
                      variant="primary"
                      class="align-middle mr-2"
                    ></b-spinner>
                    <strong class="text-primary">Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(icon)="slot">
                  <i :class="rowIcon(slot.item)"></i>
                </template>

                <template v-slot:cell()="row">
                  <div
                    v-if="
                      options.badges &&
                      options.badges.find((obj) => obj.key == row.field.key)
                    "
                  >
                    <span
                      v-html="
                        rowBadgeCell(
                          row.item,
                          options.badges.find(
                            (obj) => obj.key == row.field.key
                          ),
                          options
                        )
                      "
                    ></span>
                  </div>
                  <div v-else>{{ row.value }}</div>
                </template>
                <template v-if="options.actions" v-slot:cell(actions)="row">
                  <div id="actions-container" v-if="options.actions_as_elipses">
                    <b-button
                      variant="link"
                      size="sm"
                      title="Actions"
                      :id="'popover-target-' + row.item.id"
                      @click="$root.$emit('bv::hide::popover')"
                    >
                      <i class="fa fa-ellipsis-h text-primary"></i>
                    </b-button>
                    <b-popover
                      container="actions-container"
                      triggers="click blur"
                      placement="leftbottom"
                      :target="'popover-target-' + row.item.id"
                    >
                      <div>
                        <b-nav vertical>
                          <b-nav-item
                            :title="action.label"
                            v-for="action in rowActionCell(row.item, options)"
                            :key="action.key"
                            @click.stop="
                              rowClick(action.key, row, options.bvtid)
                            "
                          >
                            <b-row class="px-2">
                              <b-col class="px-0">
                                <span class="text-normal">{{
                                  action.label
                                }}</span>
                              </b-col>
                              <b-col cols="1">
                                <i :class="rowActionIcon(action, row.item)"></i>
                              </b-col>
                            </b-row>
                          </b-nav-item>
                        </b-nav>
                      </div>
                    </b-popover>
                  </div>
                  <div v-else>
                    <b-button
                      variant="link"
                      size="sm"
                      v-for="action in rowActionCell(row.item, options)"
                      :key="action.key"
                      @click.stop="rowClick(action.key, row, options.bvtid)"
                      :title="action.label"
                    >
                      <i :class="rowActionIcon(action, row.item)"></i>
                    </b-button>
                  </div>
                </template>

                <template v-slot:row-details>
                  <b-card>
                    <component
                      :is="options.component.name"
                      :selection="btable_selected"
                      :config="cconfig"
                      @discard="toolClick('discard')"
                      @refresh="toolClick('refresh')"
                    ></component>
                  </b-card>
                </template>
                <template v-slot:foot()="row">
                  <span v-if="row.field.totalled" class="strong text-primary">
                    {{ row.field.total }}</span
                  >
                  <span v-else></span>
                </template>
              </b-table>
            </div>

            <template #overlay>
              <div class="text-center">
                <p id="cancel-label">{{ options.overlay.message }}</p>
                <hr />
                <b-row>
                  <b-col>
                    <b-button
                      v-for="(button, index) in options.overlay.buttons"
                      :key="index"
                      :style="button.style ? button.style : 'width: 80px'"
                      :class="
                        button.class
                          ? button.class
                          : button.dispatch
                          ? null
                          : 'ml-2'
                      "
                      :variant="
                        button.variant
                          ? button.variant
                          : button.dispatch
                          ? 'outline-primary'
                          : 'outline-secondary'
                      "
                      :size="button.size ? button.size : 'sm'"
                      :squared="button.squared ? button.squared : true"
                      @click="
                        button.dispatch
                          ? dispatcher(button.dispatch)
                          : (options.overlay_show = false)
                      "
                      >{{ button.label }}</b-button
                    >
                  </b-col>
                </b-row>
              </div>
            </template>
          </b-overlay>
          <b-row class="excelsheetbuttons px-1 mb-3 mt-n2">
            <b-col>
              <div v-if="busy">
                <i class="fa fa-spinner fa-spin"></i>
                <span class="ml-1">Updating ...</span>
              </div>
              <span class="small" v-if="!busy"
                >Found {{ this[options.bvtid + "_items"].length }} rows</span
              >
            </b-col>

            <b-col class="text-right">
              <b-link
                id="pnr-excel"
                class="mr-2 excel"
                @click="
                  $helpers.outputExcel({
                    items: [this.options.bvtid + '_items'],
                  })
                "
                title="Send to excel"
              >
                <i class="fa fa-file-excel-o" aria-hidden="true"></i>
              </b-link>
              <b-tooltip target="pnr-excel" triggers="hover"
                >Grid to excel</b-tooltip
              >
              <!-- <b-link
                id="link-clear"
                class="excel"
                @click="cutit"
                title="Clear It"
              >
                <i class="fa fa-eraser" aria-hidden="true"></i>
              </b-link>
              <b-tooltip target="link-clear" triggers="hover"
                >Clear It</b-tooltip
              > -->
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="auto ml-auto">
              <b-input-group class="z-0">
                <b-form-radio-group
                  id="multiple"
                  v-model="multiple"
                  :options="[
                    { text: 'Multiple', value: true },
                    { text: 'Single', value: false },
                  ]"
                  buttons
                  button-variant="outline-success"
                  size="sm"
                  name="radio-btn-outline"
                  :debounce="options.debounce"
                ></b-form-radio-group>
              </b-input-group>
            </b-col>
            <b-tooltip target="multiple" triggers="hover" placement="right"
              >Select Multiple or Single edit mode</b-tooltip
            >
          </b-row>
        </div>
      </b-card-body>
      <div class="px-3 mt-3">
        <b-row>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-row no-gutters>
              <b-col>
                <b-form-group
                  label="Type?"
                  label-for="credit"
                  label-cols="12"
                  label-size="sm"
                >
                  <b-input-group class="z-0">
                    <b-form-radio-group
                      v-model="paste.credit"
                      :options="[
                        { text: 'Credit', value: true },
                        { text: 'Sale', value: false },
                      ]"
                      buttons
                      button-variant="outline-success"
                      size="sm"
                      name="radio-btn-outline"
                      :debounce="options.debounce"
                    ></b-form-radio-group>
                    <!-- <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        @click="paste.credit = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append> -->
                  </b-input-group>
                </b-form-group></b-col
              >
              <b-col cols="5">
                <b-form-group label="Line" label-for="line" label-cols="12">
                  <b-input-group>
                    <b-form-input
                      type="text"
                      v-model="paste.line"
                      placeholder="Line"
                      size="sm"
                      :disabled="true"
                      trim
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        @click="paste.line = ''"
                        :disabled="true"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group> </b-form-group
              ></b-col>
            </b-row>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label="Ticket" label-for="ticket" label-cols="12">
              <b-input-group>
                <b-form-input
                  type="text"
                  v-model="paste.ticketno"
                  placeholder="Ticket"
                  size="sm"
                  trim
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="paste.ticketno = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <!-- <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
              <treeselect
                placeholder="Select slac..."
                searchPromptText="Type at least 3 chars..."
                v-model="paste.slac"
                :clearable="true"
                :async="true"
                :load-options="treeselect_loadSLAC"
                :show-count="true"
                :flatten-search-results="true"
                :disable-branch-nodes="true"
                :matchKeys="['id']"
                search-nested
              >
                <div slot="value-label" slot-scope="{ node }">
                  {{ node.raw.id }}
                </div>
              </treeselect>
            </b-form-group>
          </b-col> -->
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group
              label-cols="12"
              label="Supplier BL A/C"
              label-size="sm"
            >
              <treeselect
                placeholder="Select blac..."
                searchPromptText="Type at least 3 chars..."
                v-model="paste.blac"
                :clearable="true"
                :async="true"
                :load-options="treeselect_loadBLAC"
                :show-count="true"
                :flatten-search-results="true"
                :disable-branch-nodes="true"
                :matchKeys="['id']"
                search-nested
              >
                <div slot="value-label" slot-scope="{ node }">
                  {{ node.raw.id }}
                </div>
              </treeselect>
            </b-form-group>
          </b-col>

          <!-- <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group
              label="Supplier Type"
              label-for="bltype"
              label-cols="12"
            >
              <treeselect
                instanceId="bltype"
                type="number"
                v-model="paste.bltype"
                :clearable="true"
                :options="suppliertype_options"
              ></treeselect>
            </b-form-group>
          </b-col> -->

          <!-- <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group
              label="Supplier Type"
              label-for="bltype"
              label-cols="12"
            >
              <b-input-group>
                <b-form-input
                  type="text"
                  v-model="paste.bltype"
                  placeholder="Enter BL type"
                  size="sm"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="paste.bltype = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col> -->
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label-cols="12" label="Date Travel" label-size="sm">
              <b-input-group>
                <b-form-datepicker
                  v-model="paste.datetravel"
                  size="sm"
                  label-help
                  hide-header
                  locale="en-GB"
                  placeholder="Select date"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                ></b-form-datepicker>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="paste.datetravel = null"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label-cols="12" label="Route" label-size="sm">
              <b-input-group>
                <b-form-input
                  v-model="paste.route"
                  :debounce="options.debounce"
                  placeholder="Route"
                  trim
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="paste.route = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label-cols="12" label="Passenger" label-size="sm">
              <b-input-group>
                <b-form-input
                  v-model="paste.passenger"
                  :debounce="options.debounce"
                  placeholder="Passenger"
                  trim
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="paste.passenger = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group
              label="Cost Centre"
              label-for="costcentre"
              label-cols="12"
            >
              <b-input-group>
                <b-form-input
                  type="text"
                  v-model="paste.costcentre"
                  placeholder="Enter cost centre"
                  size="sm"
                  trim
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="paste.costcentre = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label="Booker" label-for="booker" label-cols="12">
              <b-input-group>
                <b-form-input
                  type="text"
                  v-model="paste.booker"
                  placeholder="Enter booker"
                  size="sm"
                  trim
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="paste.booker = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-row>
              <b-col>
                <b-form-group
                  label="Qty"
                  label-for="qty"
                  label-cols="12"
                  class="text-right"
                >
                  <b-input-group>
                    <b-form-input
                      type="text"
                      v-model="paste.qty"
                      placeholder="Qty"
                      size="sm"
                      class="text-right"
                      trim
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        @click="paste.qty = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  label="Price"
                  label-for="costtotal"
                  label-cols="12"
                  class="text-right"
                >
                  <!-- <label
                style="padding-top: 0.3em"
                class="text-primary mr-2 inline label-right"
                >{{ line.totalprice }}
              </label> -->
                  <b-input-group class="">
                    <b-form-input
                      type="text"
                      v-model="paste.costtotal"
                      placeholder="Price"
                      size="sm"
                      class="text-right"
                      trim
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        @click="paste.costtotal = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-row>
              <b-col>
                <b-form-group
                  label="Taxes"
                  label-for="taxes"
                  label-cols="12"
                  class="text-right"
                >
                  <!-- <label
                style="padding-top: 0.3em"
                class="text-primary mr-2 inline label-right"
                >{{ line.totaltaxes }}
              </label> -->
                  <b-input-group>
                    <b-form-input
                      type="text"
                      v-model="paste.taxes"
                      placeholder="Taxes"
                      size="sm"
                      class="text-right"
                      trim
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        @click="paste.taxes = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  label="Fees"
                  label-for="fees"
                  label-cols="12"
                  class="text-right"
                >
                  <!-- <label
                style="padding-top: 0.3em"
                class="text-primary mr-2 inline label-right"
                >{{ line.totalfees }}
              </label> -->
                  <b-input-group>
                    <b-form-input
                      type="text"
                      v-model="paste.fees"
                      placeholder="Fees"
                      size="sm"
                      class="text-right"
                      trim
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        @click="paste.fees = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3" class="text-right">
            <b-row>
              <b-col>
                <b-form-group
                  label="Sale"
                  label-for="saletotal"
                  label-cols="12"
                >
                  <label
                    style="font-size: 16px"
                    class="text-primary inline label-right"
                    >{{ paste.saletotal | currency("") }}
                  </label>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3" class="text-right">
            <b-form-group
              label="Calculation"
              label-for="calculation"
              label-cols="12"
            >
              <div class="itemlinecalculation text-right">
                <span class="text-primary mx-1">{{ paste.qty }}</span>
                <span>x</span>               
                <span class="text-primary mx-1">{{ paste.costtotal }}</span>
                <span>+</span>
                <span class="text-primary mx-1">{{ paste.qty }}</span>
                <span>x</span>
                <span class="text-primary mx-1">{{ paste.taxes }}</span>
                <span>+</span>
                <span class="text-primary mx-1">{{ paste.fees }}</span>
              </div>
              <!-- <label
                style="font-size: 15px"
                class="text-primary inline label-left"
                >=
              </label> -->
              <!-- <label
                style="font-size: 15px"
                class="text-primary inline ml-1 mr-1"
              >
                {{ paste.qty }}
                <span style="font-size: 14px" class="text-white">x</span>
                {{ paste.costtotal }}
              </label>
              <label style="font-size: 15px" class="text-white inline"
                >+
              </label>
              <label
                style="font-size: 15px"
                class="text-primary inline ml-1 mr-1"
              >
                {{ paste.qty }}
                <span style="font-size: 14px" class="text-white">x</span>
                {{ paste.taxes }}
              </label>
              <label style="font-size: 15px" class="text-white inline"
                >+
              </label>
              <label
                style="font-size: 15px"
                class="text-primary inline ml-1 mr-1"
              >
                {{ paste.fees }}
              </label> -->
            </b-form-group>
          </b-col>
        </b-row>

        <b-row v-if="1 == 0">
          <b-col cols="auto" class="px-2 my-auto w-25px">
            <!-- <i class="fa fa-times text-primary"></i> -->
          </b-col>

          <b-col cols="12" sm="3" md="2" xl="2"> </b-col>
          <b-col cols="auto" class="px-2 my-auto w-25px">
            <!-- <i class="fa fa-plus text-primary"></i> -->
          </b-col>

          <b-col cols="12" sm="3" md="2" xl="2"> </b-col>
          <b-col cols="auto" class="px-2 my-auto w-25px">
            <!-- <i class="fa fa-plus text-primary"></i> -->
          </b-col>
          <b-col cols="12" sm="3" md="2" xl="2"> </b-col>
          <b-col cols="auto" class="px-2 my-auto w-25px">
            <!-- <i class="fa fa-plus text-danger"></i> -->
          </b-col>
        </b-row>
        <b-row v-if="1 == 0" no-gutters>
          <b-col cols="12" sm="3" md="2" xl="2">
            <b-form-group label="Sale" label-for="saletotal" label-cols="12">
              <b-input-group>
                <b-form-input
                  type="text"
                  v-model="paste.saletotal"
                  placeholder="Sale"
                  size="sm"
                  trim
                  :disabled="true"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="paste.saletotal = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="3" md="2" xl="2"> </b-col>
          <b-col cols="auto" class="px-2 my-auto w-25px">
            <!-- <i class="fa fa-times text-primary"></i>  -->
          </b-col>
          <b-col cols="12" sm="3" md="2" xl="2">
            <label
              style="font-size: 16px"
              class="text-primary inline label-right"
              >{{ line.totalprice }}
            </label>
          </b-col>
          <b-col cols="auto" class="px-2 my-auto">
            <i class="fa fa-plus text-primary"></i>
          </b-col>
          <b-col cols="12" sm="3" md="2" xl="2">
            <label
              style="font-size: 16px"
              class="text-primary inline label-right"
              >{{ line.totaltaxes }}
            </label>
          </b-col>
          <b-col cols="auto" class="px-2 my-auto">
            <i class="fa fa-plus text-primary"></i>
          </b-col>
          <b-col cols="12" sm="3" md="2" xl="2">
            <label
              style="font-size: 16px"
              class="text-primary inline label-right"
              >{{ line.totalfees }}
            </label>
          </b-col>
          <b-col cols="auto" class="px-2 my-auto">
            <i class="fa fa-exchange text-primary"></i>
          </b-col>
          <b-col cols="12" sm="3" md="2" xl="2">
            <label style="" class="text-primary inline label-right"
              >{{ paste.saletotal }}
            </label>
          </b-col>
        </b-row>

        <b-card-footer class="mt-2">
          <b-row align-h="end">
            <b-col class="text-left">
              <div v-if="busy">
                <i class="fa fa-spinner fa-spin text-primary"></i>
              </div>
              <div v-else>
                <span v-html="message"></span>
              </div>
            </b-col>
            <b-col class="text-right" cols="8">
              <b-button
                squared
                size="sm"
                variant="secondary"
                class="mr-1"
                @click="discard"
              >
                <i class="fa fa-chevron-left pr-1"></i>Back
              </b-button>
              <b-button squared size="sm" variant="primary" @click="saveit">
                <i class="fa fa-check"></i>
                Post It
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "SLTransactionsItems",
  data() {
    return {
      busy: false,
      suppliertype_options: [],
      multiple: true,
      paste: {
        entry: null,
        line: null,
        credit: false,
        ticketno: null,
        slac: null,
        blac: null,
        bltype: null,
        datetravel: null,
        route: null,
        passenger: null,
        qty: 0,
        costtotal: 0,
        taxes: 0,
        fees: 0,
        saletotal: 0,
        booker: null,
        costcentre: null,
      },
      line: {
        totalprice: "13,500.00",
        totaltaxes: "122.50",
        totalfees: "0.00",
      },
      item: {},
      items: [],
      options: {
        title: "SL Transactions Lines",
        icon: "fa fa-sitemap text-primary",
        debounce: 500,
        bvtid: "ctable",
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-30px",
          },
          {
            key: "entry",
            label: "Entry",
            sortable: true,
          },
          {
            key: "line",
            label: "Line",
            sortable: true,
          },
          {
            key: "ticketno",
            label: "TicketNo",
            sortable: true,
          },
          // {
          //   key: "slac",
          //   label: "SLAC",
          //   sortable: true,
          // },
          {
            key: "blac",
            label: "BLAC",
            sortable: true,
          },
          {
            key: "bltype",
            label: "Type",
            sortable: true,
          },
          {
            key: "datetravel",
            label: "Date Travel",
            sortable: true,
          },
          {
            key: "route",
            label: "Route",
            sortable: true,
          },
          {
            key: "passenger",
            label: "Passenger",
            sortable: true,
          },
          {
            key: "costcentre",
            label: "Cost Centre",
            sortable: true,
          },
          {
            key: "booker",
            label: "Booker",
            sortable: true,
          },
          {
            key: "qty",
            label: "QTY",
            sortable: true,
          },
          {
            key: "costtotal",
            label: "Price",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
          },

          {
            key: "taxes",
            label: "Taxes",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
            // totalled: true,
            // total: 0,
          },
          {
            key: "fees",
            label: "Fees",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
            // totalled: true,
            // total: 0,
          },
          {
            key: "saletotal",
            label: "Sale",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
            totalled: true,
            total: 0,
          },
          {
            key: "credit",
            label: "Type",
            sortable: true,
            // class: "text-left",
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions",
          },
        ],
        badges: [
          {
            key: "credit",
            type: "badge",
            Credit: "danger",
            Sale: "primary",
            formatter: (value, key, item) => {
              if (value == true) {
                return "Credit";
              } else {
                return "Sale";
              }
            },
          },
        ],
        actions: [
          {
            key: "copy",
            label: "Copy down",
            icon: "fa fa-download",
            single: true,
            multiple: false,
          },
        ],
        actions_as_elipses: false,
        modal: {},
        component: {},
        overlay_show: false,
        overlay: {},
      },
    };
  },
  computed: {
    readonly() {
      return false;
    },
  },
  methods: {
    async loadDDL() {
      console.log("loadDDL");
      this.busy = true;

      try {
        const response = await this.$apollo.query({
          query: gql`
            query suppliertypes {
              suppliertypes {
                id
                label
              }
            }
          `,
        });
        this.suppliertype_options = response.data.suppliertypes;
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
    },
    async load() {
      this.busy = true;

      let variables = {
        id: this.idselected,
        dateformat: "DD/MM/YY",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query SLTransactions($id: String, $dateformat: String) {
              SLTransactions(id: $id, dateformat: $dateformat) {
                id
                ref
                eventcode
                slac
                datetravel
                yourref
                items {
                  entry
                  line
                  credit
                  ticketno
                  slac
                  blac
                  bltype
                  datetravel
                  route
                  passenger
                  qty
                  costtotal
                  taxes
                  fees
                  saletotal
                  booker
                  costcentre
                }
              }
            }
          `,
          variables,
        });
        console.log(response.data.SLTransactions[0]);

        if (response.data.SLTransactions.length > 0) {
          this.item = response.data.SLTransactions[0];
          this.item.datetravel = this.$moment(
            this.item.datetravel,
            "DD/MM/YY"
          ).format("YYYY-MM-DD");
          this.tableItems(
            this.item.items,
            this.options.bvtid,
            this.options.fields
          );
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    async _toolClick(a) {
      console.log("local toolClick: ", a);
      // this.cconfig.find((o) => o.key == "eventcode").value = this.eventcode;
      switch (a) {
        case "copy":
          this.copyit();
          break;
      }
      return;
    },
    _toolDisabled(a) {
      console.log("local toolDisabled: ", a);
      // switch (a) {
      //   case "lines":
      //     return this.btable_selected.length > 0 ? false : true;
      // }
    },
    copyit() {
      console.log("copyit: ", this[this.options.bvtid + "_selected"][0]);
      let copy = this[this.options.bvtid + "_selected"][0];
      for (var prop in copy) {
        if (prop == "datetravel") {
          this.paste[prop] = this.$moment(copy[prop], "DD/MM/YY").format(
            "YYYY-MM-DD"
          );
        } else {
          this.paste[prop] = copy[prop];
        }
      }
      this.multiple = false;
    },
    cutit() {
      for (var prop in this.paste) {
        this.paste[prop] = null;
      }
      this.paste["credit"] = false;
      this.paste["entry"] = null;
    },
    async saveit() {
      console.log("saveit: ", this[this.options.bvtid + "_selected"][0]);
      let items = this[this.options.bvtid + "_selected"];
      this.busy = true;

      for (var j = 0; j < items.length; ++j) {
        for (var prop in this.paste) {
          if (this.paste[prop] || this.paste[prop] == 0) {
            items[j][prop] = this.paste[prop];
          }
        }
      }

      let row = {
        id: this.idselected,
        slac: this.item.slac,
        datetravel: this.item.datetravel,
        eventcode: this.item.eventcode,
        yourref: this.item.yourref,
        items,
      };

      let variables = {
        rows: [row],
        dateformat: "DD/MM/YY",
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation saveSLTransactions(
              $rows: [SLTransaction_input]
              $dateformat: String
            ) {
              saveSLTransactions(rows: $rows, dateformat: $dateformat) {
                id
              }
            }
          `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }
      await this.load();
      this.busy = false;
    },
  },
};
</script>

<style>
</style>